import QRCodeStyling from "qr-code-styling";

(function () {
    "use strict";

    function initQr(el) {
        const url = el.getAttribute("data-qr-link");
        if (!url) return;

        if (el.dataset.qrReady === "1") return;
        el.dataset.qrReady = "1";

        el.innerHTML = "";

        // Optional: allow setting QR color via data attribute
        // Example: <span class="qr-image" data-qr-link="..." data-qr-color="#272526"></span>
        const color = (el.getAttribute("data-qr-color") || "").trim();
        const dotColor = color || "#1A1919";

        const qr = new QRCodeStyling({
            width: 160,
            height: 160,
            type: "svg",
            data: url,
            margin: 0,
            qrOptions: { errorCorrectionLevel: "M" },
            dotsOptions: { type: "square", color: dotColor },
            cornersSquareOptions: { type: "square", color: dotColor },
            cornersDotOptions: { type: "square", color: dotColor },
            backgroundOptions: { color: "transparent" },
        });

        qr.append(el);
    }

    function initAll() {
        document.querySelectorAll(".qr-image[data-qr-link]").forEach(initQr);
    }

    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", initAll);
    } else {
        initAll();
    }
})();